import { Chip, IconButton, Typography } from '@mui/material';
import ToolTipOnText from '../../../../components/Tooltip/Tooltip';
import CurrencyConverter from '../../../../utils/currencyConverter';
import IdealcustomerSize from './IdealCustomerSize.svg';
import CompanySize from './CompanySize.svg';

export const TableColumns = [
	{
		name: 'Email Address',
		selector: (row: any) => row.email,
		sortable: true,
		center: true,
		cell: (row: any, index: number) => (
			<div style={{ textAlign: 'start', width: '100%' }}>
				<ToolTipOnText
					ellipsisOnOverflow={
						// @ts-ignore
						!(
							document?.getElementsByClassName('tool')[index]?.clientWidth <=
							document?.getElementsByClassName('channel_name')[index]
								?.clientWidth
						)
					}
					disableInteraction={false}
					title={row.email}
				>
					<Typography noWrap>{row.email}</Typography>
				</ToolTipOnText>
			</div>
		),
	},
	{
		name: 'AI Score',
		selector: (row: any) => row.lead_score_ml,
		sortable: true,
		center: true,
		cell: (row: any) => parseFloat(row.lead_score_ml).toFixed(2) + '%',
	},
	{
		name: 'Channel',
		selector: (row: any) => row.channel,
		sortable: true,
		center: true,
		cell: (row: any) => row.channel,
	},
	{
		name: 'Source',
		selector: (row: any) => row.source,
		sortable: true,
		center: true,
		cell: (row: any) => row.source,
	},
	{
		name: 'Stage',
		selector: (row: any) => row.stage_name_cat,
		sortable: true,
		center: true,
		cell: (row: any) => (
			<ToolTipOnText title={row.stage_name_cat ?? '-'} ellipsisOnOverflow>
				{row.stage_name_cat ?? '-'}
			</ToolTipOnText>
		),
	},
];

export const OppurtunityScoringTableColumns = [
	{
		name: 'Opportunity Name',
		selector: (row: any) => row.oppr_name,
		sortable: true,
		width: '20rem',
		center: true,
		cell: (row: any, index: number) => (
			<div
				className='cohortReport__forBoldText'
				style={{ textAlign: 'start', width: '100%' }}
			>
				<ToolTipOnText
					className='tool'
					ellipsisOnOverflow={
						// @ts-ignore
						!(
							document?.getElementsByClassName('tool')[index]?.clientWidth <=
							document?.getElementsByClassName('channel_name')[index]
								?.clientWidth
						)
					}
					disableInteraction={false}
					title={row.oppr_name}
				>
					<Typography className='channel_name' noWrap>
						{row.oppr_name}
					</Typography>
				</ToolTipOnText>
			</div>
		),
	},
	{
		name: 'Score',
		selector: (row: any) => row.lead_score_ml,
		sortable: true,
		center: true,
		cell: (row: any) => (
			<div className='cohortReport__forBoldText'>
				{parseFloat(row.lead_score_ml).toFixed(2) + '%'}
			</div>
		),
	},
	{
		name: 'Channel',
		selector: (row: any) => row.channel,
		sortable: true,
		center: true,
		cell: (row: any) => <div className='channel_name'>{row.channel}</div>,
	},
	{
		name: 'Source',
		selector: (row: any) => row.source,
		sortable: true,
		center: true,
		cell: (row: any) => <div className='channel_name'>{row.source}</div>,
	},
	{
		name: 'Revenue',
		selector: (row: any) => row.amount,
		sortable: true,
		center: true,
		cell: (row: any) => (
			<ToolTipOnText title={row.amount ?? '-'} ellipsisOnOverflow>
				<div className='channel_name'>{'$' + row.amount ?? '-'}</div>
			</ToolTipOnText>
		),
	},
	{
		name: 'Stage',
		selector: (row: any) => row.stage_name_cat,
		sortable: true,
		center: true,
		cell: (row: any) => (
			<ToolTipOnText title={row.stage_name_cat ?? '-'} ellipsisOnOverflow>
				<div className='channel_name'>{row.stage_name_cat ?? '-'}</div>
			</ToolTipOnText>
		),
	},
	{
		name: 'Closed Date',
		selector: (row: any) => row.close_date_local,
		sortable: true,
		center: true,
		cell: (row: any) => (
			<ToolTipOnText title={row.close_date_local ?? '-'} ellipsisOnOverflow>
				<div className='channel_name'>{row.close_date_local ?? '-'}</div>
			</ToolTipOnText>
		),
	},
];

export const leadType = ['Overall', 'Grade A', 'Grade B', 'Grade C'];

export const TableColumnsforOppurtunityScoring = [
	{
		name: 'Email Address',
		selector: (row: any) => row.email,
		sortable: true,
		center: true,
		cell: (row: any, index: number) => (
			<div
				className='cohortReport__forBoldText'
				style={{ textAlign: 'start', width: '100%' }}
			>
				<ToolTipOnText
					className='tool'
					ellipsisOnOverflow={
						// @ts-ignore
						!(
							document?.getElementsByClassName('tool')[index]?.clientWidth <=
							document?.getElementsByClassName('channel_name')[index]
								?.clientWidth
						)
					}
					disableInteraction={false}
					title={row.email}
				>
					<Typography className='channel_name' noWrap>
						{row.email}
					</Typography>
				</ToolTipOnText>
			</div>
		),
	},
	{
		name: 'AI Score',
		selector: (row: any) => row.lead_score_ml,
		sortable: true,
		center: true,
		cell: (row: any) => (
			<div className='cohortReport__forBoldText'>
				{parseFloat(row.lead_score_ml).toFixed(2) + '%'}
			</div>
		),
	},
	{
		name: 'Channel',
		selector: (row: any) => row.channel,
		sortable: true,
		center: true,
		cell: (row: any) => <div className='channel_name'>{row.channel}</div>,
	},
	{
		name: 'Source',
		selector: (row: any) => row.source,
		sortable: true,
		center: true,
		cell: (row: any) => <div className='channel_name'>{row.source}</div>,
	},
	{
		name: 'Stage',
		selector: (row: any) => row.stage_name_cat,
		sortable: true,
		center: true,
		cell: (row: any) => (
			<ToolTipOnText title={row.stage_name_cat ?? '-'} ellipsisOnOverflow>
				<div className='channel_name'>{row.stage_name_cat ?? '-'}</div>
			</ToolTipOnText>
		),
	},
];

export const TableColumnsforAccountScoring = [
	{
		name: '',
		selector: 'email',
		sortable: true,
		center: true,
		cell: (row: any, index: number) => (
			<div
				className='cohortReport__forBoldText'
				style={{ textAlign: 'start', width: '100%' }}
			>
				<ToolTipOnText
					className='tool'
					ellipsisOnOverflow={
						// @ts-ignore
						!(
							document?.getElementsByClassName('tool')[index]?.clientWidth <=
							document?.getElementsByClassName('channel_name')[index]
								?.clientWidth
						)
					}
					disableInteraction={false}
					title={row.name}
				>
					<Typography className='channel_name' noWrap>
						{row.name}
					</Typography>
				</ToolTipOnText>
			</div>
		),
	},
	{
		name: (
			<div className='header_boxes'>
				<IconButton className='icons_header_boxes' disabled>
					<img src={CompanySize} height={50} width={50} />
				</IconButton>
				Company Size
			</div>
		),
		selector: (row: any) => row.number_of_employees,
		sortable: true,
		center: true,
		cell: (row: any) => row.number_of_employees,
	},
	{
		name: (
			<div className='header_boxes'>
				<IconButton className='icons_header_boxes' disabled>
					<img src={IdealcustomerSize} height={50} width={50} />
				</IconButton>
				Ideal Customer Size
			</div>
		),
		selector: (row: any) => row.source,
		sortable: true,
		center: true,
		cell: (row: any) => row.source ?? '-',
	},
	{
		name: (
			<div className='header_boxes'>
				<IconButton className='icons_header_boxes' disabled>
					<svg
						width='50'
						height='50'
						viewBox='0 0 71 72'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'
					>
						<circle cx='35.4271' cy='36.1332' r='35.225' fill='#1A1A1A' />
						<g clip-path='url(#clip0_0_1)'>
							<path
								d='M31.83 28.1406C31.83 26.6365 30.6063 25.4131 29.1025 25.4131C27.5988 25.4131 26.375 26.6365 26.375 28.1406C26.375 29.6443 27.5988 30.8677 29.1025 30.8677C30.6063 30.8677 31.83 29.6444 31.83 28.1406ZM27.9375 28.1406C27.9375 27.4982 28.4601 26.9756 29.1025 26.9756C29.7449 26.9756 30.2675 27.4982 30.2675 28.1406C30.2675 28.7826 29.7449 29.3052 29.1025 29.3052C28.4601 29.3052 27.9375 28.7826 27.9375 28.1406Z'
								fill='#606060'
							/>
							<path
								d='M23.707 36.8179C23.707 37.2493 24.0565 37.5991 24.4883 37.5991H33.7168C34.1486 37.5991 34.498 37.2493 34.498 36.8179C34.498 33.8718 32.1009 31.4746 29.1552 31.4746H29.0499C26.1042 31.4746 23.707 33.8718 23.707 36.8179ZM29.0499 33.0371H29.1552C30.9718 33.0371 32.4938 34.3253 32.8547 36.0366H25.3504C25.7113 34.3253 27.2333 33.0371 29.0499 33.0371Z'
								fill='#606060'
								stroke='#606060'
								stroke-width='0.5'
							/>
							<path
								d='M41.749 36.6641C40.2452 36.6641 39.0215 37.8874 39.0215 39.3916C39.0215 40.8953 40.2452 42.1187 41.749 42.1187C43.2527 42.1187 44.4765 40.8953 44.4765 39.3916C44.4765 37.8874 43.2527 36.6641 41.749 36.6641ZM41.749 40.5562C41.1066 40.5562 40.584 40.0336 40.584 39.3916C40.584 38.7492 41.1066 38.2266 41.749 38.2266C42.3914 38.2266 42.914 38.7492 42.914 39.3916C42.914 40.0336 42.3914 40.5562 41.749 40.5562Z'
								fill='#606060'
							/>
							<path
								d='M41.8017 42.7266H41.6964C38.7507 42.7266 36.3535 45.1237 36.3535 48.0698C36.3535 48.5013 36.7029 48.8511 37.1348 48.8511H46.3633C46.7951 48.8511 47.1445 48.5013 47.1445 48.0698C47.1445 45.1237 44.7474 42.7266 41.8017 42.7266ZM37.9969 47.2886C38.3578 45.5773 39.8798 44.2891 41.6964 44.2891H41.8017C43.6182 44.2891 45.1403 45.5773 45.5012 47.2886H37.9969Z'
								fill='#606060'
								stroke='#606060'
								stroke-width='0.5'
							/>
							<path
								d='M40.1133 27.3594H35.4258C34.994 27.3594 34.6445 27.7092 34.6445 28.1406C34.6445 28.5721 34.994 28.9219 35.4258 28.9219H40.1133C41.4057 28.9219 42.457 29.9732 42.457 31.2656V34.5371C42.457 34.9686 42.8065 35.3184 43.2383 35.3184C43.6701 35.3184 44.0195 34.9686 44.0195 34.5371V31.2656C44.0195 29.1119 42.2671 27.3594 40.1133 27.3594Z'
								fill='#606060'
								stroke='#606060'
								stroke-width='0.5'
							/>
							<path
								d='M30.7383 45.3418C29.4459 45.3418 28.3945 44.2905 28.3945 42.998V39.7266C28.3945 39.2951 28.0451 38.9453 27.6133 38.9453C27.1815 38.9453 26.832 39.2951 26.832 39.7266V42.998C26.832 45.1518 28.5845 46.9043 30.7383 46.9043H34.3165C34.7483 46.9043 35.0977 46.5545 35.0977 46.123C35.0977 45.6916 34.7483 45.3418 34.3165 45.3418H30.7383Z'
								fill='#606060'
								stroke='#606060'
								stroke-width='0.5'
							/>
						</g>
						<defs>
							<clipPath id='clip0_0_1'>
								<rect
									width='25'
									height='25'
									fill='white'
									transform='translate(22.9258 24.6318)'
								/>
							</clipPath>
						</defs>
					</svg>
				</IconButton>
				Engagements
			</div>
		),
		selector: (row: any) => row.stage_name_cats,
		sortable: true,
		center: true,
		cell: (row: any) => (
			<ToolTipOnText title={row.stage_name_cats ?? '-'} ellipsisOnOverflow>
				{row.stage_name_cat ?? '-'}
			</ToolTipOnText>
		),
	},
	{
		name: (
			<div className='header_boxes'>
				<IconButton className='icons_header_boxes' disabled>
					<svg
						width='50'
						height='50'
						viewBox='0 0 71 72'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'
					>
						<circle cx='35.352' cy='36.1332' r='35.225' fill='#1A1A1A' />
						<g clip-path='url(#clip0_0_1)'>
							<path
								d='M39.5173 42.3402C39.7935 42.3402 40.0585 42.4499 40.2538 42.6453C40.4492 42.8406 40.5589 43.1056 40.5589 43.3819C40.5589 43.6581 40.4492 43.9231 40.2538 44.1184C40.0585 44.3138 39.7935 44.4235 39.5173 44.4235H38.4756C38.1993 44.4235 37.9344 44.3138 37.739 44.1184C37.5437 43.9231 37.4339 43.6581 37.4339 43.3819C37.4339 43.1056 37.5437 42.8406 37.739 42.6453C37.9344 42.4499 38.1993 42.3402 38.4756 42.3402H39.5173ZM37.4339 40.2569C37.1577 40.2569 36.8927 40.1471 36.6973 39.9518C36.502 39.7564 36.3923 39.4915 36.3923 39.2152V38.1735H34.3089V39.2152C34.3089 39.4915 34.1992 39.7564 34.0038 39.9518C33.8085 40.1471 33.5435 40.2569 33.2673 40.2569C32.991 40.2569 32.726 40.1471 32.5307 39.9518C32.3353 39.7564 32.2256 39.4915 32.2256 39.2152V35.0485C32.2256 34.2197 32.5548 33.4249 33.1409 32.8388C33.7269 32.2528 34.5218 31.9235 35.3506 31.9235C36.1794 31.9235 36.9742 32.2528 37.5603 32.8388C38.1463 33.4249 38.4756 34.2197 38.4756 35.0485V39.2152C38.4756 39.4915 38.3658 39.7564 38.1705 39.9518C37.9751 40.1471 37.7102 40.2569 37.4339 40.2569ZM36.3923 36.0902V35.0485C36.3923 34.7723 36.2825 34.5073 36.0872 34.3119C35.8918 34.1166 35.6269 34.0069 35.3506 34.0069C35.0743 34.0069 34.8094 34.1166 34.614 34.3119C34.4187 34.5073 34.3089 34.7723 34.3089 35.0485V36.0902H36.3923ZM34.61 41.611L32.9308 43.3089C32.8838 43.3562 32.8204 43.3837 32.7537 43.3856C32.687 43.3876 32.6222 43.3638 32.5725 43.3194L31.9308 42.6527C31.7374 42.4546 31.4733 42.3415 31.1964 42.3381C30.9196 42.3348 30.6528 42.4416 30.4548 42.635C30.2567 42.8284 30.1435 43.0925 30.1402 43.3693C30.1369 43.6461 30.2437 43.9129 30.437 44.111L31.0891 44.7819C31.5295 45.2214 32.1263 45.4683 32.7485 45.4683C33.3707 45.4683 33.9675 45.2214 34.4079 44.7819L36.0912 43.0694C36.2636 42.8691 36.3534 42.6108 36.3425 42.3469C36.3316 42.0829 36.2207 41.8329 36.0325 41.6476C35.8442 41.4622 35.5925 41.3553 35.3284 41.3485C35.0643 41.3418 34.8075 41.4356 34.61 41.611ZM44.7256 31.5662V44.4235C44.7239 45.8043 44.1747 47.1281 43.1983 48.1045C42.2219 49.0809 40.8981 49.6302 39.5173 49.6319H31.1839C29.8031 49.6302 28.4793 49.0809 27.5029 48.1045C26.5265 47.1281 25.9772 45.8043 25.9756 44.4235V29.8402C25.9772 28.4594 26.5265 27.1356 27.5029 26.1592C28.4793 25.1828 29.8031 24.6335 31.1839 24.6319H37.7912C38.4756 24.6301 39.1535 24.7641 39.7857 25.026C40.4179 25.2879 40.992 25.6727 41.4745 26.1579L43.1995 27.8829C43.6848 28.3655 44.0695 28.9395 44.3314 29.5717C44.5934 30.204 44.7273 30.8819 44.7256 31.5662ZM40.0016 27.6308C39.8536 27.4836 39.6913 27.3513 39.5173 27.236V29.8402H42.1214C42.0058 29.6661 41.8732 29.5038 41.7256 29.3558L40.0016 27.6308ZM42.6423 31.9235H39.5173C38.9647 31.9235 38.4348 31.704 38.0441 31.3133C37.6534 30.9226 37.4339 30.3927 37.4339 29.8402V26.7152H31.1839C30.3551 26.7152 29.5603 27.0444 28.9742 27.6305C28.3882 28.2165 28.0589 29.0114 28.0589 29.8402V44.4235C28.0589 45.2523 28.3882 46.0472 28.9742 46.6332C29.5603 47.2193 30.3551 47.5485 31.1839 47.5485H39.5173C40.3461 47.5485 41.1409 47.2193 41.727 46.6332C42.313 46.0472 42.6423 45.2523 42.6423 44.4235V31.9235Z'
								fill='#606060'
							/>
						</g>
						<defs>
							<clipPath id='clip0_0_1'>
								<rect
									width='25'
									height='25'
									fill='white'
									transform='translate(22.8506 24.6318)'
								/>
							</clipPath>
						</defs>
					</svg>
				</IconButton>
				AI Score
			</div>
		),
		selector: (row: any) => row.lead_score_ml,
		sortable: true,
		center: true,
		cell: (row: any) => parseFloat(row.lead_score_ml).toFixed(2) + '%',
	},
	{
		name: (
			<div className='header_boxes'>
				<IconButton className='icons_header_boxes' disabled>
					<svg
						width='50'
						height='50'
						viewBox='0 0 71 72'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'
					>
						<circle cx='35.2777' cy='36.1332' r='35.225' fill='#1A1A1A' />
						<g clip-path='url(#clip0_0_1)'>
							<path
								d='M43.6097 24.6318H26.943C25.838 24.6318 24.7782 25.0708 23.9968 25.8522C23.2154 26.6336 22.7764 27.6934 22.7764 28.7985V41.2985C22.7764 42.4036 23.2154 43.4634 23.9968 44.2448C24.7782 45.0262 25.838 45.4652 26.943 45.4652H29.9639L34.6003 49.385C34.7884 49.5441 35.0268 49.6315 35.2732 49.6315C35.5196 49.6315 35.7581 49.5441 35.9462 49.385L40.5889 45.4652H43.6097C44.7148 45.4652 45.7746 45.0262 46.556 44.2448C47.3374 43.4634 47.7764 42.4036 47.7764 41.2985V28.7985C47.7764 27.6934 47.3374 26.6336 46.556 25.8522C45.7746 25.0708 44.7148 24.6318 43.6097 24.6318ZM45.693 41.2985C45.693 41.851 45.4735 42.3809 45.0828 42.7716C44.6921 43.1623 44.1622 43.3818 43.6097 43.3818H40.5889C40.0965 43.382 39.62 43.5565 39.2441 43.8745L35.2764 47.2256L31.3107 43.8745C30.9342 43.5561 30.457 43.3815 29.9639 43.3818H26.943C26.3905 43.3818 25.8606 43.1623 25.4699 42.7716C25.0792 42.3809 24.8597 41.851 24.8597 41.2985V28.7985C24.8597 28.246 25.0792 27.7161 25.4699 27.3254C25.8606 26.9347 26.3905 26.7152 26.943 26.7152H43.6097C44.1622 26.7152 44.6921 26.9347 45.0828 27.3254C45.4735 27.7161 45.693 28.246 45.693 28.7985V41.2985Z'
								fill='#606060'
							/>
							<path
								d='M30.068 31.9232H35.2764C35.5526 31.9232 35.8176 31.8134 36.0129 31.6181C36.2083 31.4227 36.318 31.1578 36.318 30.8815C36.318 30.6052 36.2083 30.3403 36.0129 30.1449C35.8176 29.9496 35.5526 29.8398 35.2764 29.8398H30.068C29.7918 29.8398 29.5268 29.9496 29.3315 30.1449C29.1361 30.3403 29.0264 30.6052 29.0264 30.8815C29.0264 31.1578 29.1361 31.4227 29.3315 31.6181C29.5268 31.8134 29.7918 31.9232 30.068 31.9232Z'
								fill='#606060'
							/>
							<path
								d='M40.4847 34.0068H30.068C29.7918 34.0068 29.5268 34.1166 29.3315 34.3119C29.1361 34.5073 29.0264 34.7722 29.0264 35.0485C29.0264 35.3248 29.1361 35.5897 29.3315 35.7851C29.5268 35.9804 29.7918 36.0902 30.068 36.0902H40.4847C40.761 36.0902 41.0259 35.9804 41.2213 35.7851C41.4166 35.5897 41.5264 35.3248 41.5264 35.0485C41.5264 34.7722 41.4166 34.5073 41.2213 34.3119C41.0259 34.1166 40.761 34.0068 40.4847 34.0068Z'
								fill='#606060'
							/>
							<path
								d='M40.4847 38.1738H30.068C29.7918 38.1738 29.5268 38.2836 29.3315 38.4789C29.1361 38.6743 29.0264 38.9392 29.0264 39.2155C29.0264 39.4918 29.1361 39.7567 29.3315 39.9521C29.5268 40.1474 29.7918 40.2572 30.068 40.2572H40.4847C40.761 40.2572 41.0259 40.1474 41.2213 39.9521C41.4166 39.7567 41.5264 39.4918 41.5264 39.2155C41.5264 38.9392 41.4166 38.6743 41.2213 38.4789C41.0259 38.2836 40.761 38.1738 40.4847 38.1738Z'
								fill='#606060'
							/>
						</g>
						<defs>
							<clipPath id='clip0_0_1'>
								<rect
									width='25'
									height='25'
									fill='white'
									transform='translate(22.7764 24.6318)'
								/>
							</clipPath>
						</defs>
					</svg>
				</IconButton>
				PipeLine Product
			</div>
		),
		selector: (row: any) => row.stage_name_cat,
		sortable: true,
		center: true,
		cell: (row: any) => (
			<ToolTipOnText title={row.stage_name_cat ?? '-'}>
				<div>{row.stage_name_cat ?? '-'}</div>
			</ToolTipOnText>
		),
	},
];

export const TableColumnsLeadsByChannel = [
	{
		name: 'Channel',
		selector: (row: any) => row.channel,
		sortable: true,
		center: true,
		cell: (row: any, index: number) => (
			<div
				className='cohortReport__forBoldText'
				style={{ textAlign: 'start', width: '100%' }}
			>
				<ToolTipOnText
					className='tool'
					ellipsisOnOverflow={
						// @ts-ignore
						!(
							document?.getElementsByClassName('tool')[index]?.clientWidth <=
							document?.getElementsByClassName('channel_name')[index]
								?.clientWidth
						)
					}
					disableInteraction={false}
					title={row.channel ?? '-'}
				>
					<Typography className='channel_name' noWrap>
						{row.channel ?? '-'}
					</Typography>
				</ToolTipOnText>
			</div>
		),
	},
	{
		name: 'Grade A',
		selector: (row: any) => row.COUNT_A,
		sortable: true,
		center: true,
		cell: (row: any) => (
			<div
				style={{
					width: '100%',
					display: 'flex',
					justifyContent: 'space-around',
				}}
			>
				<div className='channel_name'>{row.PERCENTAGE_A + '%' ?? '-'}</div>

				<div className='channel_name'>{row.COUNT_A ?? '-'}</div>
			</div>
		),
	},
	{
		name: 'Grade B',
		selector: (row: any) => row.COUNT_B,
		sortable: true,
		center: true,
		cell: (row: any) => (
			<div
				style={{
					width: '100%',
					display: 'flex',
					justifyContent: 'space-around',
				}}
			>
				<div className='channel_name'>{row.PERCENTAGE_B + '%' ?? '-'}</div>

				<div className='channel_name'>{row.COUNT_B ?? '-'}</div>
			</div>
		),
	},
	{
		name: 'Grade C',
		selector: (row: any) => row.COUNT_C,
		sortable: true,
		center: true,
		cell: (row: any) => (
			<div
				style={{
					width: '100%',
					display: 'flex',
					justifyContent: 'space-around',
				}}
			>
				<div className='channel_name'>{row.PERCENTAGE_C + '%' ?? '-'}</div>

				<div className='channel_name'>{row.COUNT_C ?? '-'}</div>
			</div>
		),
	},
	{
		name: 'Total',
		selector: (row: any) => row.COUNT_TOTAL,
		sortable: true,
		center: true,
		cell: (row: any) => (
			<div
				style={{
					width: '100%',
					display: 'flex',
					justifyContent: 'space-around',
				}}
			>
				<div className='channel_name'>{row.PERCENTAGE_TOTAL + '%' ?? '-'}</div>

				<div className='channel_name'>{row.COUNT_TOTAL ?? '-'}</div>
			</div>
		),
	},
];

export const ImportantMetrixTable = [
	{
		name: '',
		selector: '',
		center: true,
		cell: (row: any, index: number) => (
			<div
				className='cohortReport__forBoldText'
				style={{ textAlign: 'center', width: '100%' }}
			>
				<ToolTipOnText
					className='tool'
					ellipsisOnOverflow={
						// @ts-ignore
						!(
							document?.getElementsByClassName('tool')[index]?.clientWidth <=
							document?.getElementsByClassName('channel_name')[index]
								?.clientWidth
						)
					}
					disableInteraction={false}
					title={row.title}
				>
					<Typography className='channel_name' noWrap>
						{row.title}
					</Typography>
				</ToolTipOnText>
			</div>
		),
	},
	{
		name: 'Grade A',
		selector: (row: any) => row.A,
		center: true,
		cell: (row: any) => (
			<ToolTipOnText title={row.A} ellipsisOnOverflow>
				{parseFloat(row.A).toFixed(2)}
			</ToolTipOnText>
		),
	},
	{
		name: 'Grade B',
		selector: (row: any) => row.B,
		center: true,
		cell: (row: any) => (
			<ToolTipOnText title={row.B} ellipsisOnOverflow>
				<div className='channel_name'>{row.B}</div>
			</ToolTipOnText>
		),
	},
	{
		name: 'Grade C',
		selector: (row: any) => row.C,
		center: true,
		cell: (row: any) => (
			<ToolTipOnText title={row.C} ellipsisOnOverflow>
				<div className='channel_name'>{row.C}</div>
			</ToolTipOnText>
		),
	},
];

export const setDataforLeadScoring = (
	label: any,
	props: any,
	setCircularGraphsData: any,
	setLeadEstimatesStateData: any
) => {
	const getDataValues = (grade: any) => ({
		one_actual_percentage: props?.[grade]?.one_actual_percentage ?? '-',
		one_pred_percentage: props?.[grade]?.one_pred_percentage ?? '-',
		zero_actual_percentage: props?.[grade]?.zero_actual_percentage ?? '-',
		zero_pred_percentage: props?.[grade]?.zero_pred_percentage ?? '-',
		totalLeads: CurrencyConverter(props?.[grade]?.lead) ?? '-',
		openLeads: CurrencyConverter(props?.[grade]?.pipeline_lead) ?? '-',
		predictiveEconomics: isNaN(props?.[grade]?.predicted_revenue)
			? '-'
			: '$' + CurrencyConverter(props?.[grade]?.predicted_revenue),
		avgWinRate: CurrencyConverter(props?.[grade]?.average_lead_score) ?? '-',
	});
	const values: any = (() => {
		switch (label.toLowerCase()) {
			case 'overall':
				return getDataValues(`all`);
			case 'grade a':
				return getDataValues(`a`);
			case 'grade b':
				return getDataValues(`b`);
			case 'grade c':
				return getDataValues(`c`);
			default:
				return {};
		}
	})();

	const circularGraphsData = [
		{
			label: 'Actual',
			text: 'Closed Won',
			value: values.one_actual_percentage,
		},
		{
			label: 'Predictive',
			text: 'Closed Won',
			value: values.one_pred_percentage,
		},
		{
			label: 'Actual',
			text: 'Open Opty. + Closed Lost',
			value: values.zero_actual_percentage,
		},
		{
			label: 'Predictive',
			text: 'Open Opty. + Closed Lost',
			value: values.zero_pred_percentage,
		},
	];

	// Set state for leadEstimatesStateData
	const leadEstimatesStateData = [
		{
			stats: values.totalLeads,
			title: 'Total Leads',
		},
		{
			stats: values.openLeads,
			title: 'Open Leads',
		},
		{
			stats: values.predictiveEconomics,
			title: 'Predictive Economic Value',
		},
		{
			stats: values.avgWinRate,
			title: 'Avg. Lead Score (Open Leads)',
		},
	];

	// Update component state using setters passed as arguments
	setCircularGraphsData(circularGraphsData);
	setLeadEstimatesStateData(leadEstimatesStateData);
};

export const setDataforOppurtunityScoring = (
	label: any,
	props: any,
	setCircularGraphsData: any,
	setLeadEstimatesStateData: any
) => {
	const getDataValues = (grade: any) => ({
		one_actual_percentage: props?.[grade]?.one_actual_percentage ?? '-',
		one_pred_percentage: props?.[grade]?.one_pred_percentage ?? '-',
		zero_actual_percentage: props?.[grade]?.zero_actual_percentage ?? '-',
		zero_pred_percentage: props?.[grade]?.zero_pred_percentage ?? '-',
		totalLeads: CurrencyConverter(props?.[grade]?.lead) ?? '-',
		openLeads: CurrencyConverter(props?.[grade]?.pipeline_lead) ?? '-',
		pipeline_amount: isNaN(props?.[grade]?.pipeline_revenue)
			? '-'
			: '$' + CurrencyConverter(props?.[grade]?.pipeline_revenue),
		revenue: isNaN(props?.[grade]?.revenue)
			? '-'
			: '$' + CurrencyConverter(props?.[grade]?.revenue),
		closed_won: CurrencyConverter(props?.[grade]?.converted) ?? '-',
		closed_lost: CurrencyConverter(props?.[grade]?.closed_lost) ?? '-',
	});
	const values: any = (() => {
		switch (label.toLowerCase()) {
			case 'overall':
				return getDataValues(`all`);
			case 'grade a':
				return getDataValues(`a`);
			case 'grade b':
				return getDataValues(`b`);
			case 'grade c':
				return getDataValues(`c`);
			default:
				return {};
		}
	})();

	const circularGraphsData = [
		{
			label: 'Actual',
			text: 'Closed Won',
			value: values.one_actual_percentage,
		},
		{
			label: 'Predictive',
			text: 'Closed Won',
			value: values.one_pred_percentage,
		},
		{
			label: 'Actual',
			text: 'Open Opty. + Closed Lost',
			value: values.zero_actual_percentage,
		},
		{
			label: 'Predictive',
			text: 'Open Opty. + Closed Lost',
			value: values.zero_pred_percentage,
		},
	];

	// Set state for leadEstimatesStateData
	const leadEstimatesStateData = [
		{
			stats: values.totalLeads,
			title: 'Total Opportunities',
		},
		{
			stats: values.openLeads,
			title: 'Open Opportunities',
		},
		{
			stats: values.pipeline_amount,
			title: 'Pipeline Amount',
		},
		{
			stats: values.revenue,
			title: 'Revenue',
		},
		{
			stats: values.closed_won,
			title: 'Closed Won',
		},
		{
			stats: values.closed_lost,
			title: 'Closed Lost',
		},
	];
	setCircularGraphsData(circularGraphsData);
	setLeadEstimatesStateData(leadEstimatesStateData);
};

export const setDataforAccountScoring = (
	label: any,
	props: any,
	setCircularGraphsData: any,
	setLeadEstimatesStateData: any
) => {
	const getDataValues = (grade: any) => ({
		one_actual_percentage: props?.[grade]?.one_actual_percentage ?? '-',
		one_pred_percentage: props?.[grade]?.one_pred_percentage ?? '-',
		zero_actual_percentage: props?.[grade]?.zero_actual_percentage ?? '-',
		zero_pred_percentage: props?.[grade]?.zero_pred_percentage ?? '-',
		totalLeads: CurrencyConverter(props?.[grade]?.lead) ?? '-',
		openLeads: CurrencyConverter(props?.[grade]?.pipeline_lead) ?? '-',
		predictiveEconomics: CurrencyConverter(props?.[grade]?.converted) ?? '-',
		avgWinRate: CurrencyConverter(props?.[grade]?.closed_lost) ?? '-',
	});
	const values: any = (() => {
		switch (label.toLowerCase()) {
			case 'overall':
				return getDataValues(`all`);
			case 'grade a':
				return getDataValues(`a`);
			case 'grade b':
				return getDataValues(`b`);
			case 'grade c':
				return getDataValues(`c`);
			default:
				return {};
		}
	})();

	const circularGraphsData = [
		{
			label: 'Actual',
			text: 'Closed Won',
			value: values.one_actual_percentage,
		},
		{
			label: 'Predictive',
			text: 'Closed Won',
			value: values.one_pred_percentage,
		},
		{
			label: 'Actual',
			text: 'Open Opty. + Closed Lost',
			value: values.zero_actual_percentage,
		},
		{
			label: 'Predictive',
			text: 'Open Opty. + Closed Lost',
			value: values.zero_pred_percentage,
		},
	];

	// Set state for leadEstimatesStateData
	const leadEstimatesStateData = [
		{
			stats: values.totalLeads,
			title: 'Total Accounts',
		},
		{
			stats: values.openLeads,
			title: 'Open Accounts',
		},
		{
			stats: values.predictiveEconomics,
			title: 'Closed Won',
		},
		{
			stats: values.avgWinRate,
			title: 'Closed Lost',
		},
	];

	// Update component state using setters passed as arguments
	setCircularGraphsData(circularGraphsData);
	setLeadEstimatesStateData(leadEstimatesStateData);
};

export const QuickInsightsData = [];
